import { Form, FormInstance, Select, Typography } from "antd";
import Arrowdown from "../../../common/images/png/ArrowDown.png";
import { ReactComponent as CheckSelectIcon } from "../../../common/images/svg/CheckSelect.svg";
import { ReactComponent as PlusGradientIcon } from "../../../common/images/svg/PlusGradient.svg";
import { ReactComponent as ArrowIcon } from "../../../common/images/svg/SuffixSelectIcon.svg";

const { Option } = Select;

interface ISelectSenderProps {
  isTablet: boolean;
  listSender: any[];
  senderSelected: any;
  setSenderSelected: React.Dispatch<any>;
  paramsSender: {
    start: number;
    end: number;
  };
  setParamsSender: React.Dispatch<
    React.SetStateAction<{
      start: number;
      end: number;
    }>
  >;
  setAddSender: React.Dispatch<React.SetStateAction<boolean>>;
}

const SelectSender = (props: ISelectSenderProps) => {
  const {
    isTablet,
    listSender,
    senderSelected,
    setSenderSelected,
    paramsSender,
    setParamsSender,
    setAddSender,
  } = props;

  return (
    <div>
      <div className="input-recipient">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: isTablet ? 10 : 12,
            width: "100%",
          }}
        >
          <Form.Item
            style={{ width: "100%" }}
            label="Choose sender"
            name="sender"
            validateTrigger="onBlur"
            rules={[{ required: true, message: "This field is required" }]}
          >
            <Select
              showSearch
              className="select-recipient"
              popupClassName="select-beneficiary"
              placeholder="Choose a sender"
              suffixIcon={<ArrowIcon />}
              disabled={!listSender.length}
              optionLabelProp="label"
              onChange={(id) => {
                const selected = listSender?.find(
                  (item: any) => item.id === id
                );
                setSenderSelected(selected);
              }}
              filterOption={(input, option: any) => {
                const beneficiary = listSender.find(
                  (w) => w.id === option.value
                );
                return (
                  beneficiary?.name
                    ?.toLowerCase()
                    .includes(input.toLowerCase()) ||
                  beneficiary?.fullName
                    ?.toLowerCase()
                    .includes(input.toLowerCase())
                );
              }}
            >
              {Array.isArray(listSender) &&
                listSender.map((item: any) => (
                  <Option
                    key={item.id}
                    value={item.id}
                    label={
                      <span className="ant-select-custom-value-sendmoney">
                        {item.fullName}
                      </span>
                    }
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <span className="ant-select-custom-value-sendmoney">
                        {item.fullName}
                      </span>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          gap: 6,
                        }}
                      >
                        <span
                          style={{
                            fontWeight: 400,
                            fontSize: "12px",
                          }}
                        >
                          {item.name}
                        </span>
                        <div className="dot-transaction"></div>
                        <span
                          style={{
                            fontWeight: 400,
                            fontSize: "12px",
                          }}
                        >
                          {item.country}
                        </span>
                      </div>
                    </div>
                    {senderSelected?.id === item.id && <CheckSelectIcon />}
                  </Option>
                ))}
              {listSender.length === paramsSender.end && (
                <Option key="load-more" disabled>
                  <span
                    style={{
                      fontSize: isTablet ? 12 : 14,
                      color: "rgba(29, 171, 241, 1)",
                      fontWeight: 500,
                      cursor: "pointer",
                      height: "66px",
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setParamsSender((prev) => ({
                        ...prev,
                        end: prev.end + 10,
                      }));
                    }}
                  >
                    Load more <img src={Arrowdown} />
                  </span>
                </Option>
              )}
            </Select>
          </Form.Item>
          {!listSender.length && (
            <Typography
              style={{
                fontSize: isTablet ? 10 : 12,
                fontWeight: 400,
                color: "#EC3333",
              }}
            >
              {"You haven't added a sender yet. Click 'Add' to create one"}
            </Typography>
          )}
        </div>
        <div
          className="button-add-new-recipient"
          onClick={() => setAddSender(true)}
        >
          <PlusGradientIcon />
        </div>
      </div>
      {senderSelected ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 4,
            marginTop: 8,
          }}
        >
          <Typography
            style={{
              fontSize: isTablet ? 12 : 14,
              fontWeight: 500,
              color: "white",
            }}
          >
            Company name: {senderSelected?.fullName}
          </Typography>
          <Typography
            style={{
              fontSize: isTablet ? 12 : 14,
              fontWeight: 500,
              color: "white",
            }}
          >
            Reg. No: {senderSelected?.regNo}
          </Typography>
          <Typography
            style={{
              fontSize: isTablet ? 12 : 14,
              fontWeight: 500,
              color: "white",
            }}
          >
            Country: {senderSelected?.country}
          </Typography>
        </div>
      ) : null}
    </div>
  );
};

export default SelectSender;
